export const FINISH_STARTUP_LOADING = "FINISH_STARTUP_LOADING";
export const PAGE_LOAD = "tracking.myAccount.pageLoad";
export const PAGE_INTERACTION = "tracking.myAccount.pageInteraction";
